<template>
  <div class="personal-data">
    <div class="wrapper">
      <div class="title">管理我的账号</div>
      <div class="wrapList">
        <div
          class="item acea-row row-between-wrapper"
          :class="item.uid === userInfo.uid ? 'on' : ''"
          v-for="(item, index) in switchUserInfo"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <VueCoreImageUpload
                class="btn btn-primary"
                :crop="false"
                compress="80"
                @imageuploaded="imageuploaded"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
                ref="upImg"
                v-if="item.uid === userInfo.uid"
              >
                <div class="pictrue">
                  <img :src="item.avatar" />
                </div>
              </VueCoreImageUpload>
              <div class="pictrue" v-else>
                <img :src="item.avatar" />
              </div>
              <img
                src="@assets/images/alter.png"
                class="alter"
                v-if="item.uid === userInfo.uid"
              />
            </div>
            <div class="text">
              <div class="name line1">{{ item.nickname }}</div>
              <div class="phone">绑定手机号：{{ item.phone }}</div>
            </div>
          </div>
          <div
            class="currentBnt acea-row row-center-wrapper font-color-red"
            v-if="item.uid === userInfo.uid"
          >
            当前账号
          </div>
          <div
            class="bnt font-color-red acea-row row-center-wrapper"
            v-else
            @click="switchAccounts(index)"
          >
            使用账号
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>昵称</div>
        <div class="input">
          <input type="text" v-model="userInfo.nickname" />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>ID号</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="userInfo.uid" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
      <div v-if="!userInfo.phone">
        <router-link
          :to="'/user/binding'"
          class="item acea-row row-between-wrapper"
        >
          <div>绑定手机号</div>
          <div class="input">
            点击绑定手机号<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
      <div class="item acea-row row-between-wrapper" v-else-if="userInfo.phone">
        <div>手机号码</div>
        <div class="input acea-row row-between-wrapper">
          <div class="input acea-row row-between-wrapper">
            <input
              type="text"
              :value="userInfo.phone"
              disabled
              class="id"
            /><span class="iconfont icon-suozi"></span>
          </div>
        </div>
      </div>
      <div v-if="userInfo.phone && userInfo.user_type === 'h5'">
        <router-link
          :to="'/change_password'"
          class="item acea-row row-between-wrapper"
        >
          <div>密码</div>
          <div class="input">
            点击修改密码<span class="iconfont icon-xiangyou"></span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit" style="margin-bottom: 0.7rem;">保存修改</div>
    <div
      class="logOut cart-color acea-row row-center-wrapper"
      @click="logout"
      v-if="!isWeixin"
    >
      退出登录
    </div>
    <div class="logOut cart-color acea-row row-center-wrapper" @click="uploadLocation" :disabled="isDisabled">{{btnText}}</div>
    <div id="mapContainer" hidden="true"></div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { postUserEdit, getLogout, switchH5Login, getUser, uploadLocation } from "@api/user";
import { clearAuthStatus, wxShowLocation } from "@libs/wechat";
import cookie from "@utils/store/cookie";
import store from "@/store";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";

export default {
  name: "PersonalData",
  components: {
    VueCoreImageUpload
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      avatar: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0,
      isDisabled: false,
      btnText: '上报定位',
      //地图定位
      map: null,
      AMap: null,
      location: ''
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    },

    location(newVal) {
      let that = this;
      //上报定位
      uploadLocation({
        location: that.location
      }).then(res => {
        that.$dialog.message(res.msg);
        that.btnText = '上报定位';
        that.isDisabled = false;
      }).catch(err => {
        that.$dialog.error(err);
        that.btnText = '上报定位';
        that.isDisabled = false;
      })
    }

  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.avatar = this.userInfo.avatar;
    this.isWeixin = isWeixin();
    this.getUserInfo();
    //定位
    if (isWeixin()) {  //在微信中，提前主动定位
     this.getWXLocation();
    }
  },
  methods: {
    switchAccounts: function(index) {
      let that = this;
      this.userIndex = index;
      let userInfo = this.switchUserInfo[this.userIndex];
      if (this.switchUserInfo.length <= 1) return true;
      if (userInfo === undefined)
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      if (userInfo.user_type === "h5") {
        switchH5Login()
          .then(({ data }) => {
            that.$dialog.loading.close();
            let expires_time = data.expires_time.substring(0, 19);
            expires_time = expires_time.replace(/-/g, "/");
            expires_time = new Date(expires_time).getTime() - 28800000;
            const datas = {
              token: data.token,
              expires_time: expires_time
            };
            store.commit("LOGIN", datas);
            that.$emit("changeswitch", false);
            location.reload();
          })
          .catch(err => {
            that.$dialog.loading.close();
            return that.$dialog.toast({ mes: err });
          });
      } else {
        cookie.set("loginType", "wechat", 60);
        this.$dialog.loading.close();
        this.$store.commit("LOGOUT");
        clearAuthStatus();
        this.$emit("changeswitch", false);
        location.reload();
      }
    },
    getUserInfo: function() {
      let that = this;
      getUser().then(res => {
        let switchUserInfo = res.data.switchUserInfo;
        for (let i = 0; i < switchUserInfo.length; i++) {
          if (switchUserInfo[i].uid == that.userInfo.uid) that.userIndex = i;
          if (
            !that.isWeixin &&
            switchUserInfo[i].user_type != "h5" &&
            switchUserInfo[i].phone === ""
          )
            switchUserInfo.splice(i, 1);
        }
        that.$set(this, "switchUserInfo", switchUserInfo);
      });
    },
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      if (this.switchUserInfo[this.userIndex] === undefined) return;
      this.$set(this.switchUserInfo[this.userIndex], "avatar", res.data.url);
    },

    submit: function() {
      let userInfo = this.switchUserInfo[this.userIndex];
      postUserEdit({
        nickname: trim(this.userInfo.nickname),
        avatar: userInfo.avatar
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    },
    logout: function() {
      this.$dialog.confirm({
        mes: "确认退出登录?",
        opts: () => {
          getLogout()
            .then(res => {
              this.$store.commit("LOGOUT");
              clearAuthStatus();
              location.href = location.origin;
              console.log(res);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
    uploadLocation() {
      this.isDisabled = true;
      this.btnText = '定位中...';
      let that = this;
      if(this.isWeixin) {
        if (cookie.get(LATITUDE) && cookie.get(LONGITUDE)) {
          that.location = cookie.get(LONGITUDE) + ',' + cookie.get(LATITUDE);
        } else {
          setTimeout(() => {
            that.location = cookie.get(LONGITUDE) + ',' + cookie.get(LATITUDE);
          }, 1500);
        }
      } else {
        this.getWXLocation();
      }
    },

    //======== start 定位 ========
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        this.initMap();
      }
    },

    async initMap() {
      try {
        //加载高德地图API
        this.AMap = await AMapLoader.load({
          key: 'fa774dbdacf0ce166f6c0d055702462d', //替换为你的key
          version: '2.0',
          plugins: [
            'AMap.Geolocation',  //定位插件
            //'AMap.Geocoder',     //逆地理编码插件
            //'AMap.CitySearch'    //IP定位插件
          ]
        });
        this.createMap();
      } catch (error) {
        console.info('地图组件加载失败:' + JSON.stringify(error, null, 2));
        this.$dialog.error("地图组件加载失败");
      }
    },

    createMap() {
      //创建地图实例
      this.map = new this.AMap.Map('mapContainer', {
        zoom: 12, //初始缩放级别
        resizeEnable: true //自适应窗口大小
      });
      
      this.initGeolocation();
    },

    initGeolocation() {
      const that = this;
      this.AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认：true
          timeout: 10000, // 设置定位超时时间，默认：无穷大
          offset: [10, 20],  // 定位按钮的停靠位置的偏移量
          zoomToAccuracy: true,  //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          position: 'RB' //  定位按钮的排放位置,  RB表示右下
        })

        geolocation.getCurrentPosition(function (status, result) {
          if (status == 'complete') {
            onComplete(result)
          } else {
            onError(result)
          }
        });

        function onComplete(data) {
          //data是具体的定位信息
          console.info('定位成功：' + JSON.stringify(data, null, 2));
          that.location = data.position.getLng() + ',' + data.position.getLat();
          //更新位置信息
          cookie.set(LATITUDE, data.position.getLat());
          cookie.set(LONGITUDE, data.position.getLng());
          //that.uploadLocation();
          console.info('====' + that.location);
        }

        function onError(data) {
          //定位出错
           console.info('定位失败：' + JSON.stringify(data, null, 2));
           cookie.remove(LATITUDE);
           cookie.remove(LONGITUDE);
           that.$dialog.error('定位失败');
           //回退到IP定位
           //fallbackToIPLocation();
        }
      })
    },
    //======== end 定位 ========= 
  }
};
</script>
